import React from 'react';
import {withRouter} from "react-router-dom";
import MultipleChoices from "../common/MultipleChoices";

const MultipleChoice = (props) => {
  const {field, fieldNumber} = props

  return <MultipleChoices field={field} fieldNumber={fieldNumber} />
}

export default withRouter(MultipleChoice);
